import { isEqual } from 'lodash';

const asJson = (value: unknown): unknown => (value === undefined ? undefined : JSON.parse(JSON.stringify(value)));

export const sameJson = (a: unknown, b: unknown): boolean => isEqual(asJson(a), asJson(b));
